export const DB_VERSION = 16;


const MIGRATIONS = [
    function (db: IDBDatabase) {
        console.log('apply migration 0000 -> 0001')
        db.createObjectStore('WHEEL', { autoIncrement: false, keyPath: 'uuid' });
        db.createObjectStore('LIFEPART', { autoIncrement: false, keyPath: 'uuid' });
        let goals = db.createObjectStore('GOAL', { autoIncrement: false, keyPath: 'uuid' });
        goals.createIndex('lifepart', 'lifepart', { unique: false });

        let plans = db.createObjectStore('PLAN', { autoIncrement: false, keyPath: 'uuid' });
        plans.createIndex('task', 'task', { unique: false });

        let tasks = db.createObjectStore('TASK', { autoIncrement: false, keyPath: 'uuid' });
        tasks.createIndex('goal', 'goal', { unique: false });
        tasks.createIndex('lifepart', 'lifepart', { unique: false });
        tasks.createIndex('parentTask', 'parentTask', { unique: false });
        tasks.createIndex('parentChecklistItem', 'parentChecklistItem', { unique: false });

        let chList = db.createObjectStore('CHECKLISTITEM', { autoIncrement: false, keyPath: 'uuid' });
        chList.createIndex('task', 'task', { unique: false });
        chList.createIndex('innerTask', 'innerTask', { unique: false });

    },
    function (db: IDBDatabase) {
        console.log('apply migration 0001 -> 0002')
        db.createObjectStore('LASTUPDATE', { autoIncrement: false, keyPath: 'uuid' });


    },
    function (db: IDBDatabase) {
        console.log('apply migration 0002 -> 0003')
        let store = db.createObjectStore('PENDINGUPDATES', { autoIncrement: true, keyPath: 'id' });
        store.createIndex('byDate', 'date');

    },
    function (db: IDBDatabase) {
        console.log('apply migration 0003 -> 0004')

    },
    function (db: IDBDatabase) {
        console.log('apply migration 0004 -> 0005')

    },
    function (db: IDBDatabase, transaction: any) {
        console.log('apply migration 0005 -> 0006')
        let store = transaction.objectStore('LIFEPART');
        store.createIndex('order', 'order');

    },
    function (db: IDBDatabase, transaction: any) {
        console.log('apply migration 0006 -> 0007')
        const store = transaction.objectStore('LIFEPART');
        const request = store.getAll();
        request.onsuccess = () => {
            const parts = request.result;
            parts.forEach((part: any, index: number) => {
                part.order = index;
                store.put(part);
            });
        };
    },
    function (db: IDBDatabase, transaction: any) {
        console.log('apply migration 0007 -> 0008')
        const store = transaction.objectStore('GOAL');
        const request = store.getAll();
        request.onsuccess = () => {
            const goals = request.result;
            // Группируем цели по lifepart
            const goalsByLifepart: Record<string, any[]> = {};
            goals.forEach((goal: any) => {
                const lifepart = goal.lifepart || 'default';
                if (!goalsByLifepart[lifepart]) {
                    goalsByLifepart[lifepart] = [];
                }
                goalsByLifepart[lifepart].push(goal);
            });
            // Нумеруем цели внутри каждой части
            Object.values(goalsByLifepart).forEach((lifepartGoals) => {
                lifepartGoals.sort((a, b) => (a.order || 0) - (b.order || 0));
                lifepartGoals.forEach((goal, index) => {
                    goal.order = index;
                    store.put(goal);
                });
            });
        };
    },
    function (db: IDBDatabase, transaction: any) {
        console.log('apply migration 0008 -> 0009')
        let store = transaction.objectStore('PLAN');
        store.createIndex('date', 'date');

    },
    function (db: IDBDatabase) {
        console.log('apply migration 0009 -> 0010')
        let taskLists = db.createObjectStore('TASKLIST', { autoIncrement: false, keyPath: 'uuid' });
        taskLists.createIndex('order', 'order', { unique: false });
    },
    function (db: IDBDatabase) {
        console.log('apply migration 0010 -> 0011')
        let trackers = db.createObjectStore('TRACKER', { autoIncrement: false, keyPath: 'uuid' });
        trackers.createIndex('order', 'order', { unique: false });
        let trackedValues = db.createObjectStore('TRACKED_VALUE', { autoIncrement: false, keyPath: 'uuid' });
        trackedValues.createIndex('tracker', 'tracker', { unique: false });
    },
    function (db: IDBDatabase) {
        console.log('apply migration 0011 -> 0012')
        // Добавлены поля target и targetIndicator в Tracker (не требуют изменений схемы)
    },
    function (db: IDBDatabase, transaction: any) {
        console.log('apply migration 0012 -> 0013')
        const store = transaction.objectStore('TASK');
        store.createIndex('taskList', 'taskList', { unique: false });
    },
    function (db: IDBDatabase) {
        console.log('apply migration 0013 -> 0014')
        // REFLECTION - хранилище записей рефлексии
        let reflections = db.createObjectStore('REFLECTION', { autoIncrement: false, keyPath: 'uuid' });
        reflections.createIndex('wheelId', 'wheelId', { unique: false });
        reflections.createIndex('dateFrom', 'dateFrom', { unique: false });
        reflections.createIndex('dateTo', 'dateTo', { unique: false });
        reflections.createIndex('order', 'order', { unique: false });
        
        // WHEEL_SNAPSHOT - снимки колеса баланса (1 в сутки)
        let snapshots = db.createObjectStore('WHEEL_SNAPSHOT', { autoIncrement: false, keyPath: 'uuid' });
        snapshots.createIndex('wheelId', 'wheelId', { unique: false });
        snapshots.createIndex('timestamp', 'timestamp', { unique: false });
        snapshots.createIndex('date', 'date', { unique: false });
        
        // CONCLUSION - выводы
        let conclusions = db.createObjectStore('CONCLUSION', { autoIncrement: false, keyPath: 'uuid' });
        conclusions.createIndex('wheelId', 'wheelId', { unique: false });
        conclusions.createIndex('reflectionUuid', 'reflectionUuid', { unique: false });
        conclusions.createIndex('order', 'order', { unique: false });
        
        // DECISION - решения
        let decisions = db.createObjectStore('DECISION', { autoIncrement: false, keyPath: 'uuid' });
        decisions.createIndex('wheelId', 'wheelId', { unique: false });
        decisions.createIndex('reflectionUuid', 'reflectionUuid', { unique: false });
        decisions.createIndex('order', 'order', { unique: false });
    },
    function (db: IDBDatabase) {
        console.log('apply migration 0014 -> 0015')
        // ME_SNAPSHOT - снимки раздела "Кто я и моя миссия" (1 в сутки)
        let meSnapshots = db.createObjectStore('ME_SNAPSHOT', { autoIncrement: false, keyPath: 'uuid' });
        meSnapshots.createIndex('wheelId', 'wheelId', { unique: false });
        meSnapshots.createIndex('timestamp', 'timestamp', { unique: false });
        meSnapshots.createIndex('date', 'date', { unique: false });
    },
    function (db: IDBDatabase) {
        console.log('apply migration 0015 -> 0016')
        // ROLE_EFFICIENCY_SNAPSHOT - снимки эффективности ролей (1 в сутки)
        let roleEfficiencySnapshots = db.createObjectStore('ROLE_EFFICIENCY_SNAPSHOT', { autoIncrement: false, keyPath: 'uuid' });
        roleEfficiencySnapshots.createIndex('wheelId', 'wheelId', { unique: false });
        roleEfficiencySnapshots.createIndex('timestamp', 'timestamp', { unique: false });
        roleEfficiencySnapshots.createIndex('date', 'date', { unique: false });
    },
]


export default function applyMigrations(db: IDBDatabase, oldVersion: number, newVersion: number, transaction: any) {
    let currentVersion = oldVersion || 0;
    while (currentVersion < newVersion) {
        MIGRATIONS[currentVersion](db, transaction);
        currentVersion++;
    }
}